import React from "react"
import {useTranslation} from "react-i18next"

import {GenericErrorAlert} from "../../../components/Alert.tsx"
import {Loading} from "../../../components/Loading.tsx"
import {useProspectDealNotesQuery} from "../../../queries/prospects.ts"
import {apiDateToJS} from "../../../utils/dateArithmetics.ts"
import {ActivityDayTitle} from "../../SellingDetails/shared/ActivityFeed/components/ActivityDayTitle.tsx"
import {TTabComponentProps} from "./DealDetailFlyout.tsx"

export const DealNotes: React.FC<TTabComponentProps> = ({prospect}) => {
  const {t} = useTranslation()
  const {data, isPending, error, refetch} = useProspectDealNotesQuery({prospectId: prospect?.id ?? undefined})
  const notes = data?.data.deal_notes

  return (
    <div className={"grow p-6"}>
      {error ? (
        <GenericErrorAlert retry={refetch} />
      ) : isPending ? (
        <Loading />
      ) : (notes ?? []).length === 0 && !prospect.deal_history?.trim() ? (
        <div className={"flex grow items-center justify-center text-sm"}>
          {t("SalesAssistant_Deals_Detail_NoDealNotes")}
        </div>
      ) : (
        <div className={"relative flex flex-col justify-between"}>
          {prospect.deal_history?.trim() ? (
            <div className={"divide-y divide-cr-blue-light"}>
              <div className={"flex flex-col gap-2 rounded-lg bg-cr-blue-super-light p-4"}>
                <h3 className={"text-sm font-bold"}>{t("SellingDetails_News_ActivityFeed_Note")}</h3>
                <div className={"break-words whitespace-pre-wrap"}>{prospect.deal_history}</div>
              </div>
            </div>
          ) : null}
          <div role={"list"}>
            {notes?.map(note => (
              <div key={note.id} role={"group"}>
                <ActivityDayTitle date={apiDateToJS(note.create_date)} />

                <div className={"divide-y divide-cr-blue-light"}>
                  <div className={"flex flex-col gap-2 rounded-lg bg-cr-blue-super-light p-4"}>
                    <h3 className={"text-sm font-bold"}>{t("SellingDetails_News_ActivityFeed_Note")}</h3>
                    <div className={"break-words whitespace-pre-wrap"}>{note.body}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
